import { Component, OnInit } from '@angular/core';
import { ConsultingServiceTitleEnum } from '@shared/models';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
})
export class ServicesComponent implements OnInit {
  consultingService = ConsultingServiceTitleEnum;
  constructor() {}

  ngOnInit(): void {}
}
